import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    getTaxonomyCategories,
    TaxonomyCategoriesRequest,
    TaxonomyCategoriesResponse,
} from "@tCentro/Services/CENTaxonomyCatService";

/**
 * Props passed to handler
 * (payload + onSuccess)
 */
type Props = TaxonomyCategoriesRequest & HasOnSuccess<TaxonomyCategoriesResponse>;

/**
 * Handler type
 */
type HandlerType = ApiHandler<Props, TaxonomyCategoriesResponse>;

/**
 * Call API and return data on success
 */
export const PostTaxonomyData: HandlerType = async props => {
    const result = await getTaxonomyCategories(props.parameter);

    props.parameter.onSuccess?.(result);

    // props.apiResult = result;
};

/**
 * Handler chain
 */
export const chain = [PostTaxonomyData];

const postTaxonomyData = createHandlerChainRunner(
    chain,
    "postTaxonomyData"
);

export default postTaxonomyData;
